import { Switch } from "@headlessui/react";
import { Icon } from "@iconify/react";
import bcrypt from "bcryptjs";
import React, { useEffect, useRef, useState } from "react";
import ReactModal from "react-modal";
import { toast } from "react-toastify";
import UpdateHooks from "../../Hooks/UpdateHooks";
import { Search, X } from "@mui/icons-material";
import { FaChevronDown } from "react-icons/fa";
import { MdClose } from "react-icons/md";

const SwitchRefModal = ({ resellerData, isOpen, closeModal }) => {
  const [doctors, setDoctors] = useState([]);

  const [isOpenSelect, setIsOpenSelect] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedOption, setSelectedOption] = useState(null);
  const dropdownRef = useRef(null);
  const searchInputRef = useRef(null);

  // for select
  const filteredOptions = doctors.filter(option =>
    option.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const response = await fetch(
          `https://servercareseebd.careseebd.com/api/v1/user/specific?fieldName=${"role"}&&fieldValue=${"doctor"}`,
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem(
                "careSeeAccessToken"
              )}`,
            },
          }
        );
        const data = await response.json();
        setDoctors(data?.data);

      } catch (error) {

        console.error("Error fetching doctors:", error);
      }
    };
    fetchDoctors();
  }, []);

  const handelUpdate = async (e) => {
    e.preventDefault();
    if (!selectedOption) {
      return toast.error("Please select a doctor");
    }

    await UpdateHooks(
      `https://servercareseebd.careseebd.com/api/v1/user/${resellerData?._id}`,
      {
        referralId: selectedOption?._id,
        referralName: selectedOption?.name,
        referralEmail: selectedOption?.email,
        referralPhone: selectedOption?.phone,
      }
    );
    toast.success("This user assign to a doctor");
    closeModal();
  };



  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpenSelect(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Focus search input when dropdown opens
  useEffect(() => {
    if (isOpenSelect && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [isOpenSelect]);

  const handleToggle = () => {
    setIsOpenSelect(!isOpenSelect);
    if (!isOpenSelect) {
      setSearchTerm('');
    }
  };

  const handleSelect = (option) => {
    setSelectedOption(option);
    setIsOpenSelect(false);
    setSearchTerm('');
  };

  const handleClear = () => {
    setSelectedOption(null);
    setSearchTerm('');
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={closeModal}
      className="fixed z-50 inset-0 overflow-y-auto "
      aria-hidden="true"
    >
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>
        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>
        <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6 h-[400px]">
          <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
            <button
              type="button"
              data-behavior="cancel"
              className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              onClick={closeModal}
            >
              <span className="sr-only">Close</span>
              <svg
                className="h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <div className="h-full">
            <div>
              <h2 className="text-lg font-semibold mb-5">Assign to a doctor</h2>
            </div>
            {/* second div */}

            <div className=" mt-3  flex-col justify-between items-end">

              <div className="max-w-md mx-auto ">

                <div className="relative" ref={dropdownRef}>
                  {/* Select Button */}
                  <button
                    onClick={handleToggle}
                    className="w-full px-4 py-3 text-left bg-white border border-gray-300 rounded-lg shadow-sm hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  >
                    <div className="flex items-center justify-between">
                      <span className={selectedOption ? 'text-gray-900' : 'text-gray-500'}>
                        {selectedOption ? selectedOption.name : 'Select an option...'}
                      </span>
                      <div className="flex items-center space-x-2">
                        {selectedOption && (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleClear();
                            }}
                            className="p-1 hover:bg-gray-100 bg-gray-50 rounded-full transition-colors"
                          >
                            <MdClose size={16} className="text-gray-400" />
                          </button>
                        )}
                        <FaChevronDown className={`text-gray-400 transition-transform ${isOpenSelect ? 'rotate-180' : ''}`}
                        />
                      </div>
                    </div>
                  </button>

                  {/* Dropdown */}
                  {isOpenSelect && (
                    <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg">
                      {/* Search Input */}
                      <div className="p-3 border-b border-gray-200">
                        <div className="relative">
                          <Search size={16} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                          <input
                            ref={searchInputRef}
                            type="text"
                            placeholder="Search options..."
                            value={searchTerm}
                            onChange={handleSearchChange}
                            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                          />
                        </div>
                      </div>

                      {/* Options List */}
                      <div className="max-h-44 overflow-y-auto">
                        {filteredOptions.length > 0 ? (
                          filteredOptions.map((option) => (
                            <button
                              key={option._id}
                              onClick={() => handleSelect(option)}
                              className={`w-full px-4 py-3 text-left hover:bg-gray-50 focus:bg-gray-50 focus:outline-none transition-colors ${selectedOption?._id === option._id ? 'bg-blue-50 text-blue-600' : 'text-gray-900'
                                }`}
                            >
                              {option.name}
                            </button>
                          ))
                        ) : (
                          <div className="px-4 py-3 text-gray-500 text-center">
                            No options found
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
                {selectedOption && (
                  <div className="mt-4 p-4 bg-gray-50 rounded-lg">
                    <p className="  font-medium text-secondary border-b pb-2 mb-1">Doctor Details:</p>
                    <p className="font-medium text-gray-900">Name: {selectedOption?.name}</p>
                    <p className=" text-gray-500">Email: {selectedOption?.email}</p>
                    <p className=" text-gray-500">Phone: {selectedOption?.phone}</p>
                    <p className=" text-gray-500">ID: {selectedOption?._id}</p>
                  </div>
                )}
              </div>

            </div>
            <button
              onClick={handelUpdate}
              className="px-3 py-2  rounded-md bg-secondary text-white hover:bg-secondary/90 hover:scale-105 duration-300 block ml-auto mt-6"
            >
              Update !
            </button>
          </div>
        </div>
      </div>
    </ReactModal>
  );
};

export default SwitchRefModal;
